import React      from 'react';
import PropTypes  from 'prop-types';
import { Link }   from 'react-router-dom';

import DefaultRenderer        from 'components/renderers/DefaultRenderer';
import { hasAggs, recordRef } from 'utils/reportDefinitions';
import AnswerRenderer         from 'components/fields/AnswerRenderer';

// -----------------------------------------------------
// Helpers
// -----------------------------------------------------

const ResponseIdRenderer = ({ value, publicFormInstanceId }) => {
  if (typeof value === 'string' && value.startsWith('http')) {
    return <AnswerRenderer answer={{value, field_type: 'hyperlink'}} />;
  } else {
    const url = `/organization/public_responses/x/responses/${publicFormInstanceId}`;
    return ( <Link to={ url } target='_blank' title={ value }>
                { value }
             </Link> );
  }
};


// -----------------------------------------------------
// Component Definition
// -----------------------------------------------------

const PublicFormReportCellRenderer = ({ reportDefinition, headers, record, value, columnIndex }) => {

  if(hasAggs(reportDefinition)) {
    return (
      <DefaultRenderer  record={ record }
                        value={ value }
                        columnIndex={ columnIndex } />
    );
  } else {
    const refJSON = recordRef(reportDefinition, false, headers, record, columnIndex);

    try {
      const { response_id } = refJSON && JSON.parse(refJSON);
      return (
        <ResponseIdRenderer value={ value }
                            publicFormInstanceId={ response_id } />
      );
    } catch(e) {
      return (
        <DefaultRenderer  record={ record }
                          value={ value }
                          columnIndex={ columnIndex } />
      );
    }
  }

};

// -----------------------------------------------------
// PropTypes
// -----------------------------------------------------

PublicFormReportCellRenderer.propTypes = {
  value: PropTypes.any
};

// -----------------------------------------------------
// Exports
// -----------------------------------------------------

export default PublicFormReportCellRenderer;
